'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  display: ', ';\n  align-items: center;\n  ', ';\n'], ['\n  display: ', ';\n  align-items: center;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: ', ';\n  color: ', ';\n  ', '\n'], ['\n  font-size: ', ';\n  color: ', ';\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n          margin-right: 5px;\n        '], ['\n          margin-right: 5px;\n        ']),
    _templateObject4 = _taggedTemplateLiteral(['\n          width: 100%;\n          margin-bottom: 5px;\n        '], ['\n          width: 100%;\n          margin-bottom: 5px;\n        ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var inline = _ref.inline;
  return inline ? 'flex' : 'block';
}, function (_ref2) {
  var onClick = _ref2.onClick,
      onTouchStart = _ref2.onTouchStart;
  return !!onClick || !!onTouchStart ? 'user-select: none;' : '';
});

var StyledLabel = _styledComponents2.default.div(_templateObject2, function (_ref3) {
  var big = _ref3.big;
  return big ? '16px' : '12px';
}, _colors.darkGrey, function (_ref4) {
  var inline = _ref4.inline;
  return inline ? (0, _styledComponents.css)(_templateObject3) : (0, _styledComponents.css)(_templateObject4);
});

var Label = function Label(_ref5) {
  var label = _ref5.label,
      inline = _ref5.inline,
      children = _ref5.children,
      big = _ref5.big,
      props = _objectWithoutProperties(_ref5, ['label', 'inline', 'children', 'big']);

  return label === null ? children : _react2.default.createElement(Container, _extends({
    inline: inline
  }, props), _react2.default.createElement(StyledLabel, {
    inline: inline,
    big: big
  }, label), inline ? _react2.default.createElement('div', null, children) : children);
};

Label.propTypes = {
  label: _propTypes2.default.node,
  children: _propTypes2.default.node,
  inline: _propTypes2.default.bool,
  big: _propTypes2.default.bool
};
Label.defaultProps = {
  label: null,
  inline: false,
  big: false
};
exports.default = Label;